<template lang="pug">
    el-dialog(:title="!ruleForm.id ? '新建消息': '修改俱乐部'",width="95%",:append-to-body='true' :visible.sync='visible' :modal-append-to-body='false' @close="closeForm()")
      el-form(:model="ruleForm", :inline="false" ,:rules="rules" ref="ruleForm", label-width="100px", @submit.native.prevent)
          el-card(shadow="never")
            div(slot="header")
                font(style="font-weight: bold;font-size:18px;") 面向群体
            div
                el-form-item(label="会员类型:" prop="matchName")
                    el-checkbox(:indeterminate="isIndeterminate"  v-model="mbCheckAll" @change="mbCheckAllChange" ) 全部
                    el-checkbox(v-for="(item,index) in mbList" :key="index" :label="item.type" v-model="checkedMember" @change="handleCheckedMbChange") {{item.name}}
                el-form-item(label="性别选择:" prop="matchName")
                    el-checkbox(:indeterminate="isIndeterminate"  v-model="sexCheckAll" @change="sexCheckAllChange" ) 全部
                    el-checkbox( v-for="(item,index) in sexList" :key="index" :label="item.val" v-model="checkedSex" @change="handleCheckedSexChange") {{item.name}}
                el-form-item(label="会员级别:" prop="matchName")
                    el-checkbox(:indeterminate="isIndeterminate"  v-model="levelCheckAll" @change="levelCheckAllChange" ) 全部
                    el-checkbox(v-for="(item,index) in levelList" :key="index" :label="item" v-model="checkedLevel" @change="handleCheckedLevelChange") {{item}}
                el-form-item(label="特定人群:" prop="matchName")
                    el-button(@click='addpersons'  type='primary') 添加
                    el-button(type='primary' @click='deleted()') 删除
                el-table(:data="rightData" style="width: 100%"  border @selection-change="checkAddQt")
                    el-table-column(type='selection', header-align='center', align='center', width='50')
                    el-table-column(prop='name',header-align='center',align='center',label='姓名')
                    el-table-column(prop='mobile',header-align='center',align='center',label='手机')
                    el-table-column(prop='idCard',header-align='center',align='center',label='身份证')
          el-card(shadow="never" style='margin-top:20px;')
            div(slot="header")
               font(style="font-weight: bold;font-size:18px;") 基础设置
            div
               el-form-item(label="推送方式:" prop="sendTypeArr")
                 el-checkbox-group(v-model="ruleForm.sendTypeArr" @change="sendType")
                  el-checkbox(label="1") 站内消息
                  el-checkbox(label="2") 手机短信
               el-form-item(label="消息类型:" prop="sendTypeArr")
                  el-select.sel_width_ct(v-model='ruleForm.projectType' placeholder="请选择消息类型" clearable)
                      el-option(label="站内消息" :value='1')
                      el-option(label="支付消息" :value='2')
          el-card(shadow="never" style='margin-top:20px;')
            div(slot="header")
              font(style="font-weight: bold;font-size:18px;") 消息推送
            div
              el-form-item(label="消息标题:" prop="title" )
                el-input(type='text' v-model="ruleForm.title" maxlength="50" show-word-limit  style='width:50%;' )
              el-form-item(label="推送内容:" prop="sendesson" )
                el-input(type='textarea' v-model="ruleForm.sendesson" maxlength="200" show-word-limit :rows='5' resize="none" style='width:95%;' )

      el-dialog(title="添加人员"  :visible.sync="addVisible" width="85%" :append-to-body='true' :modal-append-to-body='false')
          el-row
              el-col(:span="11")
                el-card(shadow="never")
                  div(slot="header")
                      el-row
                          el-col(:span='22')
                              el-input(v-model='searchName' clearable, style='width:80%;' placeholder="请输入姓名/级别/手机号码")
                          el-col(:span='2')
                              el-button( style='float:right;' icon='el-icon-search' @click='getLeftData') 查询
                  div
                    el-table(:data="leftData" border  @selection-change="checkLeftAll" max-height="300")
                        el-table-column(type="selection" align='center')
                        el-table-column(prop="name" label="姓名" align='center')
                        el-table-column(prop="gender" label="性别" align='center'  )
                            template(slot-scope="scope")
                              font(v-if="scope.row.gender === 0") 男
                              font(v-if="scope.row.gender === 1") 女
                        el-table-column(prop="level" label="级别" align='center'  )
                        el-table-column(prop="mobile" label="手机号码" align='center' )
                    el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
              el-col(:span="2")
                div.opSetting
                    div(@click="handelSelect")
                        el-button(style='padding:10px' icon="el-icon-d-arrow-right" size="large" :disabled="nowSelectData.length ? false:true" type="primary") 选中
                    div.spacing(@click="handleRemoveSelect")
                        el-button(style='padding:10px' icon="el-icon-d-arrow-left" size="large" :disabled="nowSelectRightData.length ? false:true"  type="primary") 取消
              el-col(:span="11")
                  el-card(shadow="never")
                      div(slot="header")
                          font.font_label 已选择的会员
                      div
                          el-table(:data="rightData" border @selection-change="checkRightAll" max-height="300")
                              el-table-column(type="selection" align='center')
                              el-table-column(prop="name" label="姓名" align='center')
                              el-table-column(prop="gender" label="性别" align='center' )
                                  template(slot-scope="scope")
                                      font(v-if="scope.row.gender === 0") 男
                                      font(v-if="scope.row.gender === 1") 女
                              el-table-column(prop="level" label="级别" align='center' )
                              el-table-column(prop="mobile" label="手机号码" align='center' )
          span.dialog-footer(slot="footer")
              el-button(type="primary" @click="addsave") 确 定
              el-button(@click="cancelAddsave") 取 消

      span.dialog-footer(slot="footer")
          el-button(type="primary"  @click="ruleFormSubmit()") 发 布
          el-button(@click="closeForm()") 取 消

</template>
<script>
const mbOptions = [{
            name: '注册会员',
            type: 1,
            price: 0.0
          },
          {
            name: '初始会员',
            type: 2,
            price: 0.0
          },
          {
            name: '荣誉会员',
            type: 3,
            price: 0.0
          }]
const sexOptions = [{ val: 0, name: '男' }, { val: 1, name: '女' }]
const levelOptions = ['0.0', '1.0', '1.5', '2.0', '2.5', '3.0', '3.5', '4.0', '4.5', '5.0']
export default {
  data () {
    return {
      checkAddQtArr: [],
      checkAllArr: [],
      searchName: '',
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      leftData: [],
      rightData: [],
      nowSelectData: [],
      nowSelectRightData: [],

      mbCheckAll: false,
      checkedMember: [],
      mbList: mbOptions,

      sexCheckAll: false,
      checkedSex: [],
      sexList: sexOptions,

      levelCheckAll: false,
      checkedLevel: [],
      levelList: levelOptions,

      addVisible: false,
      isIndeterminate: true,

      rules: {
        sendTypeArr: [{ required: true, message: '请选择推送方式！', trigger: 'blur' }],
        projectType: [{ required: true, message: '请选择消息类型！', trigger: 'blur' }],
        sendesson: [{ required: true, message: '请填写推送内容！', trigger: 'blur' }],
        title: [{ required: true, message: '请填写消息标题！', trigger: 'blur' }]
      },

      sysOrgList: [],
      cityList: [],
      provinceList: [],
      delCtRefundDisabled: true,
      cityDisbaled: true,
      provinceDisabled: true,
      nameFont: 20,
      venueIdDisabled: true,
      venueList: [],
      placesInfoList: [],
      ageMaxMenMin: 0,
      ageMaxWomenMin: 0,
      ageMaxMenMax: 100,
      ageMaxWomenMax: 100,
      menDisabled: false,
      womenDisabled: false,
      ruleForm: {
        sendTypeArr: [],
        projectType: '',
        sendesson: '',
        title: '',

        id: null,
        matchType: '1',
        matchId: '',
        matchName: '',
        userGroupId: '',
        cityCode: '',
        cityName: '',
        provinceCode: '',
        provinceName: '',
        venueId: '',
        ctType: '',
        applySize: '',
        projectType: null,
        level: '',
        bench: 1,
        applyDate: new Array(),
        matchSignStartTime: null,
        matchSignEndTime: null,
        matchStartTime: null,
        imgList: '',
        gameDescription: '',
        matchDescription: '',
        imgDetailList: '',
        repeatSign: 0,
        genderLimit: 2,
        ageLimit: '',
        ageMinMen: undefined,
        ageMaxMen: undefined,
        ageMinWomen: undefined,
        ageMaxWomen: undefined,
        scoreMin: 0,
        venueAddress: '',
        ctRefundList: [],
        ctEnrollPriceList: [
          {
            id: null,
            name: '注册会员',
            type: 1,
            price: 0.0
          },
          {
            id: null,
            name: '初始会员',
            type: 2,
            price: 0.0
          },
          {
            id: null,
            name: '荣誉会员',
            type: 3,
            price: 0.0
          }
        ]
      },
      flagType: '',
      loading: null,
      ctDisabled: true,
      matchStartTimePlaceholder: '必须先选择报名时间',
      pickerOptions: {
        // disabledDate: time =>{
        //     return(
        //         time <= new Date()
        //     )
        // }
      },
      pickerOptionsCt: null,
      // restaurants:[],
      levelDisabled: true,
      levelOptions: [],
      levelOptionsOne: [
        { value: '2.0', label: '2.0' },
        { value: '2.5', label: '2.5' },
        { value: '3.0', label: '3.0' },
        { value: '3.5', label: '3.5' },
        { value: '4.0', label: '4.0' },
        { value: '4.5', label: '4.5' },
        { value: '5.0', label: '5.0' }
      ],
      levelOptionsTwo: [
        { value: '5.0', label: '5.0' },
        { value: '6.0', label: '6.0' },
        { value: '7.0', label: '7.0' },
        { value: '8.0', label: '8.0' },
        { value: '9.0', label: '9.0' },
        { value: '10.0', label: '10.0' }
      ],
      placeholderLevel: '必须先选择比赛项目',

      visible: false,
      listImageUrl: '',
      detailImageUrl: ''
    }
  },
  mounted () {
    //this.restaurants = this.loadAll()

  },
  methods: {
    addpersons () {
      this.rightData = []
      this.getLeftData()
      this.addVisible = true
    },
    // 删除
    deleted () {
      if (this.deleteItems.length < 1) return this.$message.error('未勾选任何项目！')
      let arr = []
      this.deleteItems.forEach(i => {
        arr.push(i.id)
      })
      this.rightData = this.rightData.filter(e => arr.indexOf(e.id) == -1)
    },
    checkAddQt (val, row) {
      // console.log(val,999);
      // console.log(row,99);
      this.deleteItems = val
    },
    checkLeftAll (val) {
      this.nowSelectData = val
    },
    checkRightAll (val) {
      this.nowSelectRightData = val
    },
    addsave () {
      this.addVisible = false
    },

    cancelAddsave () {
      this.rightData = []
      this.addVisible = false
    },
    sizeChangeHandle (val) {
      this.pageIndex = 1
      this.pageSize = val
      this.getLeftData()
    },
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getLeftData()
    },
    getLeftData () {
      this.$http({
        url: this.$http.adornUrl('/mbMember/findList'),
        method: 'post',
        data: {
          page: this.pageIndex,
          limit: this.pageSize,
          name: this.searchName
        }
      }).then(data => {
        if (data && data.code === 0) {
          this.leftData = data.page.records
          this.totalPage = data.page.total
        } else {
          this.tableData = []
          this.totalPage = 0
        }
      })
    },
     // 选中
    handelSelect () {
        this.rightData = this.handleConcatArr(this.rightData, this.nowSelectData)
        this.handleRemoveTabList(this.nowSelectData, this.leftData)
        this.nowSelectData = []
    },
    // 取消
    handleRemoveSelect () {
        this.leftData = this.handleConcatArr(this.leftData, this.nowSelectRightData)
        this.handleRemoveTabList(this.nowSelectRightData, this.rightData)
        this.nowSelectRightData = []
    },
    handleConcatArr (rightData, nowSelectData) {
      let arr = []
      arr = arr.concat(rightData, nowSelectData)
      return arr
    },
    handleRemoveTabList (isNeedArr, originalArr) {
      if (isNeedArr.length && originalArr.length) {
          for (let i = 0; i < isNeedArr.length; i++) {
              for (let k = 0; k < originalArr.length; k++) {
                  if (isNeedArr[i]['name'] === originalArr[k]['name']) {
                      originalArr.splice(k, 1)
                  }
              }
          }
      }
    },

    mbCheckAllChange (val) {
      let arr = []
      mbOptions.forEach(e => {
        arr.push(e.type)
      })
      this.checkedMember = val ? arr : []
      this.isIndeterminate = false
    },
    handleCheckedMbChange (value) {
      let checkedCount = value.length
      this.mbCheckAll = checkedCount === this.mbList.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.mbList.length
    },

    sexCheckAllChange (val) {
      let arr = []
      sexOptions.forEach(e => {
        arr.push(e.val)
      })
      this.checkedSex = val ? arr : []
      this.isIndeterminate = false
    },
    handleCheckedSexChange (value) {
      let checkedCount = value.length
      this.sexCheckAll = checkedCount === this.sexList.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.sexList.length
    },

    levelCheckAllChange (val) {
      this.checkedLevel = val ? levelOptions : []
      this.isIndeterminate = false
    },
    handleCheckedLevelChange (value) {
      let checkedCount = value.length
      this.levelCheckAll = checkedCount === this.levelList.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.levelList.length
    },
    sendType () {},
    init (id, flagType) {
      this.flagType = flagType
      this.ruleForm.id = id || null
      this.visible = true
      this.rightData = []
      this.ruleForm.sendTypeArr = [],
      this.ruleForm.projectType = '',
      this.ruleForm.sendesson = '',
      this.mbCheckAll = false,
      this.checkedMember = [],
      this.sexCheckAll = false,
      this.checkedSex = [],
      this.levelCheckAll = false,
      this.checkedLevel = [],
      this.$nextTick(() => {
        this.$refs['ruleForm'].resetFields()
      })

      //数据初始化
      this.ruleForm.level = ''
      this.levelDisabled = true
      this.placeholderLevel = '必须先选择比赛项目'
      this.ctDisabled = true
      this.matchStartTimePlaceholder = '必须先选择报名时间'
      this.listImageUrl = ''
      this.detailImageUrl = ''
      this.ruleForm.ageMinMen = undefined
      this.ruleForm.ageMaxMen = undefined
      this.ruleForm.ageMinWomen = undefined
      this.ruleForm.ageMaxWomen = undefined

      this.ruleForm.ctRefundList = []

      this.ruleForm.matchSignStartTime = ''
      this.ruleForm.matchSignEndTime = ''

      this.cityDisbaled = true
      this.provinceDisabled = true
      this.venueIdDisabled = true
      this.womenDisabled = false
      this.menDisabled = false
      this.nameFont = 20
    },

    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    //新增方法
    ruleFormSubmit () {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          let idsArr = []
          this.rightData.forEach(e => {
            idsArr.push(e.id)
          })
          let data = {
            mbTypes: this.checkedMember.join(), //会员类别
            type: this.ruleForm.projectType, //消息类型
            mbGenders: this.checkedSex.join(),
            mbLevels: this.checkedLevel.join(),
            mbIds: idsArr.join(),
            byx1: this.ruleForm.sendTypeArr.join(), //推宋方式
            content: this.ruleForm.sendesson,
            title: this.ruleForm.title
          }
          this.openFullScreen()
          this.$http({
            url: this.$http.adornUrl(`/pbMessage/save`),
            method: 'post',
            data: data
          }).then(data => {
              this.loading.close()
              if (data && data.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.visible = false
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
              }
          }).catch(() => {
              this.loading.close()
          })
        }
      })
    },
    closeForm () {
      this.visible = false
    }

  }
}
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.width_ct {
  width: 50%;
}
.sel_width_ct,
.input_width_ct {
  width: 20% !important;
}
.font_later {
  padding-left: 20px;
  font-weight: bold;
  color: #909399;
}
.font_color {
  font-weight: bold;
  color: #909399;
}
.font_style {
  font-weight: bold;
  color: red;
}
.dialog-footer {
  padding-bottom: 150px;
}

.opSetting{
    text-align: center;
    margin-top:30px;

}
.spacing{
    margin-top:10px;
}

/* 分页样式 */
.el-pager li {
    padding: 0 4px;
    font-size: 13px;
    min-width: 20.5px;
    height: 28px;
    line-height: 28px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-align: center;
}

/* 文本框剩余数字提示兼容ie */
.el-textarea .el-input__count {
    color: #909399;
    background: none;
    position: absolute;
    font-size: 12px;
    bottom: 5px;
    right: 25px;
}

</style>
